import { render, staticRenderFns } from "./OrderReport.vue?vue&type=template&id=1912dcd7&scoped=true"
import script from "./OrderReport.vue?vue&type=script&lang=js"
export * from "./OrderReport.vue?vue&type=script&lang=js"
import style0 from "./OrderReport.vue?vue&type=style&index=0&id=1912dcd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1912dcd7",
  null
  
)

export default component.exports